export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7371.d20873e6.jpg";